import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class CurrencyUIListener extends UIListener {

    constructor() {
        super();
    }

    public onDetailViewReady(context: DetailViewContext): void {
        this.updateGUI(context);
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string): void {
        let isSubCurrency = context.genericObject.getObservable('IsSubCurrency');
        let baseCurrency = context.getUIFactory('BaseCurrency') as ControlFactory;

        if (isSubCurrency() === false && baseCurrency.isVisible() === true) {
            context.genericObject.getObservable('BaseCurrency.ObjectIdentValue')(null);
            context.genericObject.getObservable('BaseCurrency.PDO_ID')(0);
        }

        this.updateGUI(context);
    }

    private updateGUI(context: DetailViewContext): void {
        let isSubCurrency = context.genericObject.getObservable('IsSubCurrency');

        let baseCurrency = context.getUIFactory('BaseCurrency') as ControlFactory;
        let subCurrencyType = context.getUIFactory('SubCurrencyType.Value') as ControlFactory;
        let invSource = context.getUIFactory('invSource') as ControlFactory;
        let invTarget = context.getUIFactory('invTarget') as ControlFactory;

        if (isSubCurrency() === true) {
            baseCurrency.isVisible(true);
            subCurrencyType.isVisible(true);
            invSource.isVisible(false);
            invTarget.isVisible(false);

            baseCurrency.isRequired(true);
        } else {
            baseCurrency.isVisible(false);
            subCurrencyType.isVisible(false);
            invSource.isVisible(true);
            invTarget.isVisible(true);
        }
    }
}

ComponentManager.setUIListener('CurrencyUIListener', CurrencyUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.CurrencyUIListener', CurrencyUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');